import { useCallback, useEffect, useMemo } from 'react'

export interface GeolocPosition {
	location: { lat: number; lng: number }
	address: string | null
}


export const processGeolocPosition = (lat: number, lng: number, callback: (geoloc: GeolocPosition) => void) => {
	const location = { lat, lng }
	const position = { location, address: null }
	callback(position);
	
	const geocoder = new google.maps.Geocoder()
	geocoder.geocode({ location }, (results, status) => {
		if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
			const position = { location, address: results[0].formatted_address }
			callback(position)
		} else {
			console.error('Geocoder failed: ' + status)
		}
	})
}

export const useGeolocPosition = ({
	onChangePosition,
	onDeniedPosition,
}: {
	onChangePosition: (position: GeolocPosition) => void,
	onDeniedPosition?: () => void
}) => {
	const hasGeoLoc = navigator.geolocation

	const process = useCallback((data: GeolocationPosition) => {
		processGeolocPosition(data.coords.latitude, data.coords.longitude, onChangePosition);
	}, [onChangePosition]); 
	
	const queryPosition = useMemo(() => {
		if (!hasGeoLoc) {
			return undefined
		}

		return () => navigator.geolocation.getCurrentPosition(process, onDeniedPosition)
	}, [hasGeoLoc, processGeolocPosition])

	

	// useEffect(() => {
	// 	if (!navigator.permissions || !hasGeoLoc) {
	// 		return
	// 	}
	// 	;(async () => {
	// 		const permissions = await navigator.permissions.query({
	// 			name: 'geolocation',
	// 		})
	// 		if (permissions.state === 'granted') {
	// 			navigator.geolocation.getCurrentPosition(processGeolocPosition)
	// 		}
	// 	})()
	// }, [processGeolocPosition, hasGeoLoc])

	return { queryPosition }
}
